import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'

import config from '../../../../../../../../../config'

import { createXlsExportTask } from '../../../../../../../components/EntityStack/components/StackContent/components/ExportsContent/actions'

import { showUpsellDialog } from './actions'

const MODULE_KEY = config.modules.portfolio.key

function mapStateToProps(state, hocProps) {
    const portfolioType = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', hocProps.id, 'portfolioType'], null)

    const parameters = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'portfolios', portfolioType, 'parameters'],
        Map()
    )

    return {
        portfolioType,
        groupName: state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', hocProps.id, 'name'], 'groupName'),
        exportXls: parameters.get('exportXls', false),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ showUpsellDialog, createXlsExportTask }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
